/* eslint-disable no-unused-expressions */
import {collision} from './collision';

export class BlockFinish {
	constructor(game) {
		this.game = game;
		this.image = document.getElementById('finish');
		this.imageScale = 0.5;
		this.width = this.image.width * this.imageScale;
		this.height = this.image.height * this.imageScale;
		this.x = this.setXposition();
		this.y = this.game.ground.y - this.height;
		this.collisiion = false;
		this.speed = this.game.speed;
	}

	setXposition() {
		return this.game.width;
	}

	update() {
		if (collision(this.game.player, this) && !this.collisiion) {
			this.collisiion = true;
			this.game.start = false;
			this.game.pause();
			this.game.popupMain.openFinal();
		}

		if (this.game.finish) {
			this.x -= this.speed;
		}
	}

	draw() {
		this.game.ctx.drawImage(this.image, this.x, this.y, this.width, this.height);

		// debug hit box
		// context.strokeStyle = 'green';
		// context.strokeRect(this.x, this.y, this.width, this.height);
	}

	reset() {
		this.game.finish = false;
		this.collisiion = false;
		this.x = this.setXposition();
	}

	resize() {
		if (!this.game.finish) {
			this.x = this.setXposition();
		}

		this.y = this.game.ground.y - this.height;
	}
}
